"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function QRScanIcon(props) {
    return (react_1.default.createElement(react_native_svg_1.default, Object.assign({ width: 210, height: 210, viewBox: "0 0 210 210", fill: "none" }, props),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M199.504 210h-58.671c-1.615 0-2.691-1.077-2.691-2.692 0-1.616 1.076-2.692 2.691-2.692h58.671c2.691 0 5.113-2.424 5.113-5.116v-58.423c0-1.615 1.077-2.692 2.692-2.692 1.614 0 2.691 1.077 2.691 2.692V199.5c0 5.654-4.575 10.5-10.496 10.5zM68.705 210H10.572C4.921 210 .076 205.423.076 199.5v-58.423c0-1.615 1.077-2.692 2.692-2.692 1.614 0 2.69 1.077 2.69 2.692V199.5c0 2.692 2.423 5.116 5.114 5.116h58.133c1.615 0 2.691 1.076 2.691 2.692 0 1.615-1.345 2.692-2.691 2.692zM2.768 71.615c-1.615 0-2.692-1.076-2.692-2.692V10.5C.076 4.577 4.921 0 10.572 0h58.133c1.615 0 2.691 1.077 2.691 2.692 0 1.616-1.076 2.693-2.691 2.693H10.572c-2.691 0-5.113 2.423-5.113 5.115v58.423c0 1.615-1.077 2.692-2.691 2.692zM207.309 71.615c-1.615 0-2.692-1.076-2.692-2.692V10.5c0-2.692-2.422-5.115-5.113-5.115h-58.671c-1.615 0-2.691-1.077-2.691-2.693 0-1.615 1.076-2.692 2.691-2.692h58.671C205.156 0 210 4.577 210 10.5v58.423c0 1.615-1.077 2.692-2.691 2.692z", fill: "#436EAC" })));
}
exports.default = QRScanIcon;
